import React from "react";

import type { Messages, NavigateAction, View, ViewsProps } from ".";
import { faChevronLeft, faChevronRight } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import { Button } from "~/ui";
import { IconButton } from "~/ui/legacyFellowIndex";

import { scrollToNow } from "./utils/scrolling";

import styles from "./Toolbar.module.css";

export interface ToolbarProps<TEvent extends object = Event, TResource extends object = object> {
	date: Date;
	view: View;
	views: ViewsProps<TEvent, TResource>;
	label: string;
	localizer: { messages: Messages };
	onNavigate: (navigate: NavigateAction, date?: Date) => void;
	onView: (view: View) => void;
	children?: React.ReactNode;
	extras?: {
		right?: React.ComponentType;
		left?: React.ComponentType;
	};
}

export default function Toolbar({ onNavigate, label, extras }: ToolbarProps<Event>) {
	const navigate = React.useCallback(
		(action: NavigateAction) => () => {
			onNavigate(action);
			if (action === "TODAY") scrollToNow(250);
		},
		[onNavigate],
	);

	const RightExtra = extras?.right || null;
	const LeftExtra = extras?.left || null;

	return (
		<div className={styles.toolbar}>
			<div className={styles.leftSide}>
				{LeftExtra && <LeftExtra />}
				<span>
					<IconButton className={styles.iconButton} icon={faChevronLeft} onClick={navigate("PREV")} />
					<IconButton className={styles.iconButton} icon={faChevronRight} onClick={navigate("NEXT")} />
				</span>
				<span className={styles.toolbarTitle}>{label}</span>
				<Button size="slim" variant="secondary" onClick={navigate("TODAY")}>
					Today
				</Button>
			</div>

			{RightExtra && <RightExtra />}
		</div>
	);
}
